import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalSailingSpaceInput,
  terminalSailingSpaceInputSchema,
} from "./shared/terminalSailingSpace.input";
import {
  type TerminalSailingSpace,
  terminalSailingSpaceSchema,
} from "./shared/terminalSailingSpace.output";

/**
 * Metadata for the fetchTerminalSailingSpace endpoint
 */
export const terminalSailingSpaceMeta = {
  functionName: "fetchTerminalSailingSpace",
  endpoint: "/terminalSailingSpace",
  inputSchema: terminalSailingSpaceInputSchema,
  outputSchema: terminalSailingSpaceSchema.array(),
  sampleParams: {},
  endpointDescription: "List sailing space availability for all terminals.",
} satisfies EndpointMeta<TerminalSailingSpaceInput, TerminalSailingSpace[]>;

/**
 * Fetch function for retrieving sailing space availability for all terminals
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalSailingSpaceInput,
  TerminalSailingSpace[]
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalSailingSpaceMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalSailingSpace.endpoints").terminalSailingSpaceGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving sailing space availability for all terminals
 */
export const fetchTerminalSailingSpace: FetchFactory<
  TerminalSailingSpaceInput,
  TerminalSailingSpace[]
> = fetch;

/**
 * React Query hook for retrieving sailing space availability for all terminals
 */
export const useTerminalSailingSpace: HookFactory<
  TerminalSailingSpaceInput,
  TerminalSailingSpace[]
> = useHook;
